import { render } from "./doctemplatecreate.vue?vue&type=template&id=6ebce19e&scoped=true"
import script from "./doctemplatecreate.js?vue&type=script&lang=js"
export * from "./doctemplatecreate.js?vue&type=script&lang=js"

import "./doctemplatecreate.vue?vue&type=style&index=0&id=6ebce19e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebce19e"]])

export default __exports__